<template>
    <div>
      <v-app-bar dense color="white accent-1" fixed dark app>
        <v-toolbar-title v-if="showToggle">
          <v-app-bar-nav-icon style="color: black" @click="handleDrawerToggle"></v-app-bar-nav-icon>
        </v-toolbar-title>
        <img src="images/sunwin.png" style="margin-right: 10px;" height="36" :alt="title"/>
        <v-toolbar-title style='font-family: "Microsoft YaHei"; color: rgb(174, 174, 174); font-weight: bold; font-size: 24px;'>{{title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>

<!--          <v-toolbar-title v-if="showToggle">-->
<!--            <v-app-bar-nav-icon @click="handleDrawerToggle"></v-app-bar-nav-icon>-->
<!--          </v-toolbar-title>-->
<!--          <v-toolbar-title>{{title}}</v-toolbar-title>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-spacer></v-spacer>-->

            <v-toolbar-items>
                <v-layout style="margin-top:16px;font-family: 'Microsoft YaHei';font-size: 12px;color:#8e98af">
                    <v-layout class="pointer" @click="gotoPortal">
                        <v-img :height="16" width="16" contain src="images/home.png"></v-img>
                        <span class="ml-1">Home</span>
                    </v-layout>
                    <v-divider style="margin-top:0px;margin-left: 10px;margin-right:10px;" vertical inset/>
                    <v-layout>
                        <v-img :height="16" width="16" contain src="images/user_info.png"></v-img>
                        <span class="ml-1">{{ userName }}</span>
                    </v-layout>
                    <v-divider style="margin-top:0px;margin-left: 10px;margin-right:10px;" vertical inset/>
                    <span class="ml-1 pointer" @click="handleLogout">Exit</span>
                </v-layout>
            </v-toolbar-items>
      </v-app-bar>

<!--        <v-toolbar v-if="!hideMenu" dense color="primary accent-1" class="mt-1">-->
<!--            <v-btn text color="white" tile class="ml-5" @click="goto('containerQuery')">-->
<!--                <v-icon>mdi-package-variant-closed</v-icon>-->
<!--              SHIPMENT MANAGEMENT SYSTEM-->
<!--            </v-btn>-->
<!--          <v-btn text color="white" tile class="ml-5" @click="goto('recordQuery')">-->
<!--            <v-icon>mdi-cube-scan</v-icon>-->
<!--           SCAN RECORD-->
<!--          </v-btn>-->
<!--          <v-btn text color="white" tile class="ml-5" @click="goto('itemQuery')">-->
<!--            <v-icon>mdi-checkbox-multiple-marked-circle</v-icon>-->
<!--            Mix-size RULE-->
<!--          </v-btn>-->
<!--          <v-btn text color="white" tile class="ml-5" @click="goto('mixcodeQuery')">-->
<!--            <v-icon>mdi-barcode-scan</v-icon>-->
<!--            PRIVATE CODE-->
<!--          </v-btn>-->
<!--        </v-toolbar>-->
    </div>
</template>
<script>
    import ApmUtil from "../../util/ApmUtil";

    export default {
        name: "AppToolbar",
        props: {
            title: {},
            hideMenu: {
                type: Boolean,
                default: false
            },
            showToggle: {
                type: Boolean,
                default: true
            }
        },
        components: {},
        data() {
            return {
                isAdmin: false,
                userName: ""
            };
        },
        created() {
            // this.$request.request("SYS_USER_PROFILE", null, {async: false}).then(response => {
            //     let user = response.data;
            //     this.isAdmin = user.admin;
            //     localStorage.setItem("profile", JSON.stringify(user));
            //     this.userName = user.userName;
            // })
         let profile=JSON.parse(localStorage.getItem("profile"));
         this.userName=profile.displayName;
        },
        methods: {
            handleDrawerToggle() {
                window.theApp.$emit("APP_DRAWER_TOGGLED");
            }
            ,
            handleFullScreen() {
                ApmUtil.toggleFullScreen();
            }
            ,
            handleLogout() {
                this.logout();
            }
            ,
            handleProfile() {
            },
            goto(router) {
                this.$router.apmRoute(router, {}, {}, "menu");
            },
            gotoPortal() {
                window.location.href = this.$envConfig.portalURL;
            }
        }
        ,
        computed: {
            noticeNumber() {
                return this.$store.getters.notifications.length;
            }
        }
    }
    ;
</script>
